export const getMapOverlayTop = (appWidth) => appWidth <= 820 ? 12 : 16;

export const getSideNavWidth = (appWidth) => appWidth <= 560 ? 292 : 304;

export const getMobileMapControlsHeight = () => 40;

export const getSelectedEventPanelTop = (appWidth, showMapControls) => {
  if (appWidth <= 560 && showMapControls) {
    return getMapOverlayTop(appWidth) + getMobileMapControlsHeight() + 12;
  }

  return getMapOverlayTop(appWidth);
};

export const getHeaderHeight = (appWidth, hideHeader) => {
  if (hideHeader) {
    return 0;
  }

  return appWidth <= 560 ? 50 : 52;
};

export const getSelectedEventPanelWidth = (appWidth, sideNavOpen) => {
  if (appWidth <= 560) {
    return Math.floor(appWidth * (2 / 3));
  }

  const leftOccupiedWidth = sideNavOpen ? getSideNavWidth(appWidth) : 0;
  const availableMapWidth = Math.max(0, appWidth - leftOccupiedWidth);

  return Math.floor(Math.min(400, availableMapWidth * 0.5));
};
